import { render, staticRenderFns } from "./AdvertisingAndAffiliationPage.vue?vue&type=template&id=4c81f21c"
import script from "./AdvertisingAndAffiliationPage.vue?vue&type=script&lang=js"
export * from "./AdvertisingAndAffiliationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports